import React, { useEffect, useState } from "react";
import { RoutePath, apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { useNavigate, useParams } from "react-router-dom";

function AddProductPage() {
  const { productsApi } = apiPath;
  const { productList } = RoutePath;
  const navigate = useNavigate();

  //   // Form data
  const data = [
    {
      elementType: "file",
      label: "Product image",
      type: "Text",
      name: "image",
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Product Title",
      type: "Text",
      name: "title",
      required: false,
    },
    {
      elementType: "textField",
      label: "Product Description",
      type: "Text",
      name: "description",
      required: false,
    },
    {
      elementType: "textField",
      label: "Product URL",
      type: "Text",
      name: "link",
      required: false,
    },
  ];

  const update = async (data) => {
    const newData = {
      products: data,
    };

    const res = await updateData(productsApi, newData, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        navigate("/" + productList);
      }, 1000);
    }
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
}

export default AddProductPage;
